
import { Attachment, FilterOptions, SortOptions } from '../../types/attachment';

export const filterAttachments = (
  attachments: Attachment[],
  filters: FilterOptions
): Attachment[] => {
  let result = [...attachments];
  
  // Apply filters
  if (filters.search) {
    const searchLower = filters.search.toLowerCase();
    result = result.filter(
      (att) =>
        att.fileName.toLowerCase().includes(searchLower) ||
        att.emailSubject.toLowerCase().includes(searchLower)
    );
  }
  
  if (filters.dateRange.start) {
    result = result.filter(
      (att) => new Date(att.emailDate) >= filters.dateRange.start!
    );
  }
  
  if (filters.dateRange.end) {
    result = result.filter(
      (att) => new Date(att.emailDate) <= filters.dateRange.end!
    );
  }
  
  if (filters.sender) {
    const senderLower = filters.sender.toLowerCase();
    result = result.filter(
      (att) =>
        att.emailSender.toLowerCase().includes(senderLower) ||
        att.emailSenderName.toLowerCase().includes(senderLower)
    );
  }
  
  if (filters.fileType.length > 0) {
    result = result.filter((att) => filters.fileType.includes(att.fileType));
  }
  
  if (filters.sizeRange.min !== null) {
    result = result.filter((att) => att.fileSize >= filters.sizeRange.min!);
  }
  
  if (filters.sizeRange.max !== null) {
    result = result.filter((att) => att.fileSize <= filters.sizeRange.max!);
  }
  
  return result;
};

export const sortAttachments = (
  attachments: Attachment[],
  sortOption: SortOptions
): Attachment[] => {
  return [...attachments].sort((a, b) => {
    let comparison = 0;
    
    switch (sortOption.field) {
      case 'emailDate':
        comparison = new Date(a.emailDate).getTime() - new Date(b.emailDate).getTime();
        break;
      case 'fileSize':
        comparison = a.fileSize - b.fileSize;
        break;
      case 'fileName':
        comparison = a.fileName.localeCompare(b.fileName);
        break;
    }
    
    return sortOption.direction === 'asc' ? comparison : -comparison;
  });
};
